import { useMemo } from 'react';

import { SnippetBodyFormat } from './types';
import type { SnippetProduct, SnippetScope, SnippetData, SnippetsProvider } from './types';

const BLOCK_SERVICE_API_URL = '/gateway/api/blocks/v1';
const SNIPPETS_PATH = '/snippets';

export interface FetchSnippetParams {
	format: SnippetBodyFormat;
	product: SnippetProduct;
	scope: SnippetScope;
}

export type SnippetProviderParams = FetchSnippetParams;

export const fetchSnippets = async (params: FetchSnippetParams) => {
	const queryParams = new URLSearchParams({
		format: params.format,
		product: params.product,
		scope: params.scope,
	});

	const response = await fetch(
		`${BLOCK_SERVICE_API_URL + SNIPPETS_PATH}?${queryParams.toString()}`,
		{
			method: 'GET',
		},
	);

	if (!response.ok) {
		throw new Error('Failed to fetch snippets');
	}
	return await response.json();
};

export const createSnippetsProvider = (params: SnippetProviderParams): SnippetsProvider => ({
	getSnippets: async (): Promise<SnippetData[]> => {
		const data = await fetchSnippets(params);
		return data?.success ?? [];
	},
});

export interface SnippetsPluginOptionsParams {
	product: SnippetProduct;
	scope: SnippetScope;
}

export const useSnippetsPluginOptions = ({
	product,
	scope,
}: SnippetsPluginOptionsParams): { snippetsProvider: SnippetsProvider } =>
	useMemo(
		() => ({
			snippetsProvider: createSnippetsProvider({
				format: SnippetBodyFormat.ADF,
				product,
				scope,
			}),
		}),
		[product, scope],
	);
